/**
 *
 * Component: Table
 * Date: 21/1/2021
 *
 */

import React from 'react';
import { Table as CustomTable } from 'antd';

const Table = ({ ...rest }) => {
  return <CustomTable {...rest} />;
};

export default Table;
